import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <ContactSection />
        <TopicsSection />
        <FeaturesSection />
        <FaqSection />
        <MediaSection />
        <CardsSection />
        <IndexSection />
        <AboutSection />
        <UpdatesSection />
        <CommentsSection />
        <RankingSection />
        <AppSection />
      </main>
      <Footer />
    </div>
  );
}